import { Box, CircularProgress, Modal } from "@mui/material";

export const WaitDialog = ({ open }) => {
  if (open) {
    return (
      <Modal open={open}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          height={1}
        >
          <CircularProgress />
        </Box>
      </Modal>
    );
  }
};
